import { getApplicationTheme, setApplicationTheme } from '@sas-dvr/ltjs-commons/util/ThemeLoader';
import { useThemeData } from '@sas/nova-commons/theme';
import { useEffect } from 'react';
const ltjsThemes = ['sas_hcb', 'sas_ignite', 'sas_corporate', 'light', 'dark', 'high-contrast'];
export function useSyncAppThemeImpl(options) {
  // Sync application theme with the current nova theme
  const themeData = useThemeData();
  useEffect(() => {
    if (options.enabled) {
      setLTJSApplicationThemeImpl({
        themeName: themeData.baseThemeName
      });
    }
  }, [options.enabled, themeData.baseThemeName]);
}

/**
 * Updates the global LTJS application theme to match the given Nova base theme name.
 */
export function setLTJSApplicationThemeImpl(options) {
  const ltjsThemeName = ltjsThemes.includes(options.themeName) ? options.themeName : 'light';
  if (ltjsThemeName !== getApplicationTheme()) {
    setApplicationTheme(ltjsThemeName);
  }
}
//# sourceMappingURL=index.js.map